/**
 * 主 Joule 流水 — GET /v1/ledger
 * §1.5：limit 默认 50、最大 100；offset 最大 100000；{ items, nextOffset }
 */
import { request } from '@/common/services/request';
import type { JouleLedgerEntry, OffsetPage } from '@/types/api';

export type { JouleLedgerEntry };

export interface JouleLedgerParams {
  offset?: number;
  limit?: number;
}

/** GET /v1/ledger */
export const getJouleLedger = (
  params: JouleLedgerParams = {}
): Promise<OffsetPage<JouleLedgerEntry>> => {
  const offset = Math.max(0, Math.min(100000, Number(params.offset ?? 0) || 0));
  const limit = Math.max(1, Math.min(100, Number(params.limit ?? 50) || 50));
  return request({
    url: '/v1/ledger',
    method: 'GET',
    data: { offset, limit },
  });
};
